const production: boolean = true;

export const environment = {
  production: production,
  logo: "/assets/images/logo.png",
  profile_image_path: "https://ckfunding-api.tech4broker.online/uploads/profile_img/",
  doc_image_path: "https://ckfunding-api.tech4broker.online/uploads/documents/",
  finance_image_path: "https://ckfunding-api.tech4broker.online/uploads/finance/",
  endpoint: "https://ckfunding-api.tech4broker.online/backend",
  crm_title: "BackOffice Administrator",
  client_url: "https://client.wallcorefx.com",
  logo_width: 150,
  inner_logo_width: 80,
  ib_levels: ["ib1"],
};